module.exports = __webpack_public_path__ + "static/media/modal-success-hero.9b5c95e3.jpg";